import { routeGeometry } from './routeGeometry.js';
import { createTrafficMesh } from './createTrafficMesh.js';

export function drawTrafficRoute(state) {
  state.route = createTrafficMesh(state, routeGeometry(state.lanes), [], { unlit: true });
}
